/**
 * B545 (e) — what a REMEMBERED cart means when the sheet opens again. The
 * embed dialog removes its frame on close, so every open boots fresh with
 * the session's cartId. A cart past BROWSE whose order still holds seats
 * RESUMES at Pay; anything else (lapsed, settled, unknown) opens a fresh
 * cart silently — the buyer never reads "already on its way to payment".
 */
export type ResumeDecision =
  | { readonly kind: "keep" }
  | { readonly kind: "fresh" }
  | { readonly kind: "resume"; readonly orderId: string; readonly deadline: number };

export function resumeDecision(input: {
  readonly cart?: { readonly status: "OPEN" | "CHECKED_OUT" } | undefined;
  readonly order?: { readonly orderId: string; readonly state: string; readonly holdExpiresAt?: number | undefined } | undefined;
  readonly now: number;
}): ResumeDecision {
  if (input.cart === undefined) return { kind: "fresh" };
  if (input.cart.status === "OPEN") return { kind: "keep" };
  const order = input.order;
  if (order === undefined || order.state !== "PENDING_PAYMENT") return { kind: "fresh" };
  const deadline = order.holdExpiresAt ?? Number.POSITIVE_INFINITY;
  if (deadline <= input.now) return { kind: "fresh" };
  return { kind: "resume", orderId: order.orderId, deadline };
}
